import { useAppStore } from '@/core/stores/appStore';

export interface SalesAgentContact {
    name: string;
    phone: string;
}

/**
 * Reactive sales agent contact from profile-details (`sales_agent_details`).
 * Use in components so a cleared agent disappears as soon as the store syncs.
 */
export function useSalesAgentContact(): SalesAgentContact {
    const name = useAppStore((state) => state.auth.user?.sales_agent_name);
    const phone = useAppStore((state) => state.auth.user?.sales_agent_phone);

    return {
        name: name?.trim() || '',
        phone: phone?.trim() || '',
    };
}
